import PropTypes from 'prop-types'
import Checkbox from '@mui/material/Checkbox'
import './CheckboxWithLabel.css'

const CheckboxWithLabel = ({ className, label, name, onChange, tooltip, value }) => {
    const classNames = `checkbox-with-label ${className ?? ''}`

    return (
        <div className={classNames}>
            <Checkbox
                name={name}
                checked={value}
                onChange={onChange}
                className='checkbox'
            />
            <div className='label' title={tooltip}>{label}</div>
        </div>
    )
}

CheckboxWithLabel.propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    tooltip: PropTypes.string,
    value: PropTypes.bool
}

export default CheckboxWithLabel
